import { Route } from 'react-router';

import Credentials from '../pages/apps/Credentials';
import Permissions from '../pages/apps/Permissions';
import ProfilePage from '../pages/login/ProfilePage';
import InvalidPage from '../pages/common/InvalidPage';
import AppPage from '../pages/apps/AppPage';
import AppSpace from '../pages/apps/AppSpace';

import LandingPage from '../pages/common/LandingPage/LandingPage';
import NoAccessPage from './NoAccessPage';
import TermOfUsePage from '../pages/login/TermOfUsePage';
import Support from '../pages/support/Support';
import Contact from '../pages/contact/Contact';
import About from '../pages/about/About';
import NotFound from '../pages/notfound/NotFound';
import Terms from '../pages/terms/Terms';
import Legals from '../pages/legals/Legals';
import PrivacyPolicy from '../pages/privacypolicy/PrivacyPolicy';
import CookiePolicy from '../pages/cookiepolicy/CookiePolicy';
import Webhooks from '../pages/apps/Webhooks/Webhooks';
import WebhookDetails from '../pages/apps/Webhooks/WebhookDetails';
import CertificatesPage from '../pages/login/CertificatesPage';
import SwaggerUiApi from '../pages/apis/SwaggerUiApi';
import CombinedDocs from '../pages/combineddocs/CombinedDocs';
import Guide from '../pages/guide/Guide';
import Sdk from '../pages/sdk/Sdk';
import AuthVerification from '../pages/authVerification/authVerification';
import {keycloak} from "../keycloak-config";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  TERM_OF_USE: {
    path: '/termofuse',
    publicRoute: true,
    component: TermOfUsePage,
    exact: true,
  },
  routes: {
    ROOT: {
      path: '/',
      component: LandingPage,
      exact: true,
      publicRoute: true,
      breadcrumb: 'H', // not applied
    },
    PROFILE: {
      path: '/profile',
      component: ProfilePage,
      exact: true,
    },
    CERTIFICATES: {
      path: '/certificates',
      component: CertificatesPage,
      exact: true,
    },
    APPLIST: {
      path: '/apps',
      component: AppPage,
      exact: true,
      breadcrumb: 'Apps',
    },
    FINTODOCS: {
      path: '/docs',
      component: CombinedDocs,
      publicRoute: true,
      routes: {
        SDKS: {
          path: '/docs/sdks',
          publicRoute: true,
          routes: {
            SWAGGER: {
              path: '/docs/sdks',
              publicRoute: true,
              component: Sdk,
            },
          },
        },
        GUIDE: {
          path: '/docs/guides',
          publicRoute: true,
          routes: {
            SWAGGER: {
              path: '/docs/guides',
              publicRoute: true,
              component: Guide,
            },
          },
        },
        APIS: {
          path: '/docs/apis',
          publicRoute: true,
          routes: {
            SWAGGER: {
              path: '/docs/apis',
              publicRoute: true,
              component: SwaggerUiApi,
            },
          },
        },
      },
    },
    APPS: {
      path: '/apps/:id',
      component: AppSpace,
      routes: {
        CREDENTIALS: {
          path: '/apps/:id/credentials',
          component: Credentials,
        },
        PERMISSIONS: {
          path: '/apps/:id/permissions',
          component: Permissions,
        },
        WEBHOOKS: {
          path: '/apps/:id/webhooks',
          component: Webhooks,
        },
      },
    },
    WEBHOOKDETAILS: {
      path: '/app/:id/webhooks/:webhookId',
      component: WebhookDetails,
      exact: true,
    },
    SUPPORT: {
      path: '/support',
      component: Support,
      exact: true,
    },
    CONTACT: {
      path: '/contact',
      publicRoute: true,
      component: Contact,
      exact: true,
    },
    ABOUT: {
      path: '/about',
      publicRoute: true,
      component: About,
      exact: true,
    },
    TERMS: {
      path: '/terms',
      publicRoute: true,
      component: Terms,
      exact: true,
    },
    LEGALS: {
      path: '/legals',
      publicRoute: true,
      component: Legals,
      exact: true,
    },
    PRIVACY_POLICY: {
      path: '/privacy-policy',
      publicRoute: true,
      component: PrivacyPolicy,
      exact: true,
    },
    COOKIE_POLICY: {
      path: '/cookie-policy',
      publicRoute: true,
      component: CookiePolicy,
      exact: true,
    },
    InvalidPage: {
      path: '/invalidPage',
      publicRoute: true,
      component: InvalidPage,
      exact: true,
    },
    AuthVerification: {
      path: '/realms',
      publicRoute: true,
      component: AuthVerification,
      exact: true
    },
    NoAccessPage: {
      path: '/noAccessPage',
      publicRoute: true,
      component: NoAccessPage,
      exact: true,
    },
    _NOTFOUND: {
      path: '*',
      publicRoute: true,
      component: NotFound,
    }
  },
};

function isAllowed(route) {
  return (route.publicRoute || keycloak.authenticated) ? true : false;
}

export function getRoutes(routeParent) {
  return Object.values(routeParent).map(function (route) {
    const component = isAllowed(route) ? route.component : NoAccessPage;
    return route.path && <Route key={route.path} {...route} component={component} />;
  });
}

export function getSubRoutes(routeParent) {
  return Object.values(routeParent.routes).map((route) => {
    const component = isAllowed(route) ? route.component : NoAccessPage;
    return route.path && <Route key={route.path} {...route} component={component} />;
  });
}
